module.exports = __webpack_public_path__ + "components/star-rating/static/white/0.75-1936704aaebe8fb63ffbf1f95395f5e1.svg";